export interface PetPremiumBreakdown {
  petId?: string;
  petName?: string;
  totalPremium: number;
  basePremium: number;
  preexistingConditionsPremium: number;
  globalCoveragePremium: number;
  liabilityPremium: number;
}

export class CalculatePremiumResponse {
  totalPremium: number;
  basePremium: number;
  preexistingConditionsPremium: number;
  globalCoveragePremium: number;
  liabilityPremium: number;
  medicalFoodCoveragePremium: number;
  preventionCoveragePremium: number;
  petPremiums?: PetPremiumBreakdown[];

  constructor(data: any) {
    this.totalPremium = data.totalPremium;
    this.basePremium = data.basePremium;
    this.preexistingConditionsPremium = data.preexistingConditionsPremium;
    this.globalCoveragePremium = data.globalCoveragePremium;
    this.liabilityPremium = data.liabilityPremium;
    this.medicalFoodCoveragePremium = data.medicalFoodCoveragePremium;
    this.preventionCoveragePremium = data.preventionCoveragePremium;
    this.petPremiums = data.petPremiums;
  }
}
